/* eslint-disable no-console */

import { register } from "register-service-worker";
import { PROTOCOL } from "@/common/config";
import { STAGE } from "@/common/config";
import msg from "@/common/msg.util";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updated(reg) {
      console.log("New content is available; please refresh.");
      reg.waiting.postMessage({ type: "SKIP_WAITING" });
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
  let refreshing;

  const refresh = () => {
    window.location.href = `${PROTOCOL}//${STAGE}app.eadstock.com.br`;

    refreshing = true;
  };

  if (navigator && navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener("controllerchange", function () {
      if (refreshing) return;
      msg.confirm(
        "Nova versão disponível!",
        "Atualize a página para receber a versão mais recente.",
        {
          actions: [
            {
              text: "OK",
              btnColor: "primary",
              callback: refresh
            }
          ]
        }
      );
    });
  }
}
